// extracted by mini-css-extract-plugin
export var actionButton = "GdkMiddlewareRequestPage-module__actionButton___M+Mgg";
export var cancelButton = "GdkMiddlewareRequestPage-module__cancelButton___PVlBp";
export var checkBoxWrapper = "GdkMiddlewareRequestPage-module__checkBoxWrapper___kjof3";
export var container = "GdkMiddlewareRequestPage-module__container___r3TYw";
export var contentBox = "GdkMiddlewareRequestPage-module__contentBox___GMnTl";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var emptyContentBox = "GdkMiddlewareRequestPage-module__emptyContentBox___QN4Tf";
export var fieldsColumn = "GdkMiddlewareRequestPage-module__fieldsColumn___mixSE";
export var gdkLabel = "GdkMiddlewareRequestPage-module__gdkLabel___3R8SQ";
export var gdkLink = "GdkMiddlewareRequestPage-module__gdkLink___mx3Oi";
export var gdkMainText = "GdkMiddlewareRequestPage-module__gdkMainText___qYvIL";
export var horizontalCentering = "GdkMiddlewareRequestPage-module__horizontalCentering___xnzuc";
export var innerContentBox = "GdkMiddlewareRequestPage-module__innerContentBox___+5l7j";
export var medium = "860px";
export var modalActions = "GdkMiddlewareRequestPage-module__modalActions___vWuhJ";
export var modalBody = "GdkMiddlewareRequestPage-module__modalBody___sY0kw";
export var modalHeader = "GdkMiddlewareRequestPage-module__modalHeader___XJpKg";
export var modalTitle = "GdkMiddlewareRequestPage-module__modalTitle___wb2mY";
export var spinnerBackground = "GdkMiddlewareRequestPage-module__spinnerBackground___RHrQD";
export var spinnerWrapper = "GdkMiddlewareRequestPage-module__spinnerWrapper___o-8UP";
export var submitButtonColumn = "GdkMiddlewareRequestPage-module__submitButtonColumn___pReeb";
export var submitButtonDisabled = "GdkMiddlewareRequestPage-module__submitButtonDisabled___4OTMX";
export var title = "GdkMiddlewareRequestPage-module__title___DQZw2";
export var title2 = "GdkMiddlewareRequestPage-module__title2___g4afQ";
export var verticalCentering = "GdkMiddlewareRequestPage-module__verticalCentering___U0yTe";